import { cva } from 'class-variance-authority';

export const sonnerVariants = cva('toaster group');
